import { render, staticRenderFns } from "./DropdownToGoCollaborators.vue?vue&type=template&id=3c9af6e2&scoped=true"
import script from "./DropdownToGoCollaborators.vue?vue&type=script&lang=js"
export * from "./DropdownToGoCollaborators.vue?vue&type=script&lang=js"
import style0 from "./DropdownToGoCollaborators.vue?vue&type=style&index=0&id=3c9af6e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9af6e2",
  null
  
)

export default component.exports